import React from 'react';
import SectionHeading from './SectionHeading';
import { specifications } from '../data/content';

function Included() {
  return (
    <section className="section dark">
      <div className="container">
        <SectionHeading eyebrow="More ways to sell it">
          Also included
        </SectionHeading>
        <div className="included-grid">
          <article>
            <span className="block-number">01</span>
            <h3>Ready-to-deliver presentations</h3>
            <p>
              PowerPoint decks with speaker notes on the key topics, so
              whoever presents them isn't reading someone else's slides cold.
            </p>
          </article>
          <article>
            <span className="block-number">02</span>
            <h3>Bonus guides and checklists</h3>
            <p>
              Short one-page takeaways. The pieces that work as lead magnets
              and email content once you split them out.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}

function Specifications() {
  return (
    <section className="section light">
      <div className="container">
        <SectionHeading eyebrow="What you get">The details</SectionHeading>
        <dl className="spec-grid">
          {specifications.map(([term, value]) => (
            <div className="spec-row" key={term}>
              <dt>{term}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export { Included, Specifications };